<div class="card md:p-8" style="    width: 100%;    height: 100%; ">

    <div class="content md:w-8 my-3">
        <h1 class="font-bold text-gray-700">{{ 'sipo.settings' | translate }}</h1>
        <!--card-1 begin-->
        <div class="shadow-2 p-4 md:flex">
            <div class="md:w-6 mb-3 md:mb-0">
                <span class="font-bold text-xl block py-1">{{ 'sipo.lang' | translate }}</span>
                <span class="text-gray-400 block py-1">{{ 'sipo.lang-info' | translate }}</span>
            </div>
            <div class="w-6">
                <!--English flag field-->
                <div class="flex align-items-center">
                    <div class="w-2 py-2 text-gray-50 mr-1">
                        <img src="assets/images/flags/english.jpg" width="100%">
                    </div>
                    <div class="flex justify-content-between align-items-center w-full">
                        <span class="text-gray-400">{{ 'sipo.english' | translate }}</span>
                        <p-inputSwitch [(ngModel)]="isEnglish" [disabled]="isEnglish"
                                       (onChange)="changeLanguage('en')"></p-inputSwitch>
                    </div>
                </div>
                <!--English flag field-->
                <!--German flag field-->
                <div class="flex align-items-center mt-2">
                    <div class="w-2 py-2 text-gray-50 mr-1">
                        <img src="assets/images/flags/german.jpg" width="100%">
                    </div>
                    <div class="flex justify-content-between align-items-center w-full">
                        <span class="text-gray-400">{{ 'sipo.german' | translate }}</span>
                        <p-inputSwitch [(ngModel)]="isGerman" [disabled]="isGerman"
                                       (onChange)="changeLanguage('de')"></p-inputSwitch>
                    </div>
                </div>
                <!--German flag field-->
                <!--Turkish flag field-->
                <div class="flex align-items-center mt-2">
                    <div class="w-2 py-2 text-gray-50 mr-1">
                        <img src="assets/images/flags/turkish.jpg" width="100%">
                    </div>
                    <div class="flex justify-content-between align-items-center w-full">
                        <span class="text-gray-400">{{ 'sipo.turkish' | translate }}</span>
                        <p-inputSwitch [(ngModel)]="isTurkish" [disabled]="isTurkish"
                                       (onChange)="changeLanguage('tr')"></p-inputSwitch>
                    </div>
                </div>
                <!--Turkish flag field-->
            </div>
        </div>
        <!--card-1 end-->

        <!--card-2 begin-->
        <div class="shadow-2 p-4 mt-5">
            <div class="text-3xl font-bold mb-4">
                {{ 'sipo.signature-standards' | translate }}
            </div>
            <!--card-3 field-1 begin-->
            <div class="md:flex w-full border-bottom-1 surface-border pb-4">
                <div class="md:w-6">
                    <span class="font-bold text-xl block py-1">{{ 'sipo.evidence' | translate }}</span>
                    <span class="text-gray-400 block py-1">{{ 'sipo.evidence-info' | translate }}</span>
                </div>
                <div class="md:w-6 mt-3 md:mt-0">
                    <!---radio-button-field-1 begin-->
                    <div class="flex align-items-center mb-3 w-full">
                        <div class="w-2 py-3 mr-1 flex justify-content-center align-items-center"
                             [innerHTML]="'basic' | evidenceSvg"></div>
                        <div class="flex justify-content-between align-items-center w-10">
                            <div>
                                <span
                                    class="block text-gray-400">{{ 'sipo.simple-e-signature.long' | translate }}</span>
                            </div>
                            <p-inputSwitch [(ngModel)]="isBasic" (onChange)="changeEvidence('basic')"
                                           [disabled]="isBasic"></p-inputSwitch>
                        </div>
                    </div>
                    <!---radio-button-field-1 end-->
                    <!---radio-button-field-2 begin-->
                    <div class="flex align-items-center mb-3 w-full">
                        <div class="w-2 py-3 mr-1 flex justify-content-center align-items-center"
                             [innerHTML]="'basiccert' | evidenceSvg"></div>
                        <div class="flex justify-content-between align-items-center w-10">
                            <div>
                                <span
                                    class="block text-gray-400">{{ 'sipo.simple-e-signature-2.long' | translate }}</span>
                            </div>
                            <p-inputSwitch [(ngModel)]="isBasiccert" (onChange)="changeEvidence('basiccert')"
                                           [disabled]="isBasiccert"></p-inputSwitch>
                        </div>
                    </div>
                    <!---radio-button-field-2 end-->
                    <!---radio-button-field-3 begin-->
                    <div class="flex align-items-center mb-3 w-full">
                        <div class="w-2 py-3 mr-1 flex justify-content-center align-items-center"
                             [innerHTML]="'high' | evidenceSvg"></div>
                        <div class="flex justify-content-between align-items-center w-10">
                            <div>
                                <span
                                    class="block text-gray-400">{{ 'sipo.advanced-e-signature.long' | translate }}</span>
                            </div>
                            <p-inputSwitch [(ngModel)]="isHigh" (onChange)="changeEvidence('high')"
                                           [disabled]="isHigh"></p-inputSwitch>
                        </div>
                    </div>
                    <!---radio-button-field-3 end-->
                    <!---radio-button-field-4 begin-->
                    <div class="flex align-items-center w-full">
                        <div class="w-2 py-3 mr-1 flex justify-content-center align-items-center"
                             [innerHTML]="'max' | evidenceSvg"></div>
                        <div class="flex justify-content-between align-items-center w-10">
                            <div>
                                <span
                                    class="block text-gray-400">{{ 'sipo.qualified-e-signature.long' | translate }}</span>
                            </div>
                            <p-inputSwitch [(ngModel)]="isMax" (onChange)="changeEvidence('max')"
                                           [disabled]="isMax"></p-inputSwitch>
                        </div>
                    </div>
                    <!---radio-button-field-4 end-->
                </div>
            </div>
            <!--card-3 field-1 end-->
            <!--card-3 field-2 begin-->
            <div class="md:flex w-full py-4">
                <div class="md:w-6">
                    <span class="font-bold text-xl block py-1">{{ 'sipo.legal-space' | translate }}</span>
                    <span class="text-gray-400 block py-1">{{ 'sipo.legal-space-info' | translate }}</span>
                </div>
                <div class="md:w-6 mt-3 md:mt-0">
                    <!---radio-button-field-1 begin-->
                    <div class="flex align-items-center">
                        <div
                            class="w-2 py-2 text-gray-50 mr-1 flex justify-content-center align-items-center">
                            <img src="assets/images/flags/eu.jpeg" width="100%">
                        </div>
                        <div class="flex justify-content-between align-items-center w-full">
                            <div>
                                <span class="block text-gray-400">{{ 'sipo.eu-law.long' | translate }}
                                    ({{ 'sipo.eu-law.short' | translate }})</span>
                            </div>
                            <p-inputSwitch [(ngModel)]="isEULaws" [disabled]="isEULaws"
                                           (onChange)="changeSelectedLaws('eu')"></p-inputSwitch>
                        </div>
                    </div>
                    <!---radio-button-field-1 end-->
                    <!---radio-button-field-2 begin-->
                    <div class="flex align-items-center mt-3">
                        <div
                            class="w-2 py-2 text-gray-50 mr-1 flex justify-content-center align-items-center">
                            <img src="assets/images/flags/switzerland.webp" width="100%">
                        </div>
                        <div class="flex justify-content-between align-items-center w-full">
                            <div>
                                <span
                                    class="block text-gray-400">{{ 'sipo.swiss-law.long' | translate }} {{ 'sipo.swiss-law.short' | translate }}</span>
                            </div>
                            <!--                            <p-inputSwitch [(ngModel)]="isCHLaws" [disabled]="isCHLaws" (onChange)="changeSelectedLaws('ch')"></p-inputSwitch>-->
                            <span>{{ 'sipo.available-soon' | translate }}</span>
                        </div>
                    </div>
                    <!---radio-button-field-2 end-->
                    <!---radio-button-field-3 begin-->
                    <div class="flex align-items-center mt-3">
                        <div
                            class="w-2 py-2 text-gray-50 mr-1 flex justify-content-center align-items-center">
                            <img src="assets/images/flags/turkish.jpg" width="100%">
                        </div>
                        <div class="flex justify-content-between align-items-center w-full">
                            <div>
                                <span
                                    class="block text-gray-400">{{ 'sipo.turkish-law.long' | translate }} {{ 'sipo.turkish-law.short' | translate }}</span>
                            </div>
                            <!--                            <p-inputSwitch [(ngModel)]="isTRLaws" [disabled]="isTRLaws" (onChange)="changeSelectedLaws('tr')"></p-inputSwitch>-->
                            <span>{{ 'sipo.available-soon' | translate }}</span>
                        </div>
                    </div>
                    <!---radio-button-field-3 end-->
                </div>
            </div>
            <!--card-3 field-2 end-->
        </div>
        <!--card-2 end-->

        <!--card-3 begin-->
        <div class="shadow-2 p-4 mt-5">
            <div>
                <span class="font-bold text-xl block py-1">{{ 'sipo.delete-account' | translate }}</span>
            </div>
            <div class="md:flex">
                <div class="md:w-6">
                    <span
                        class="text-gray-400 block py-1">{{ 'sipo.delete-account-info' | translate:{appName: appConfig.name} }}</span>
                </div>
                <div class="md:w-6 flex align-items-center mt-3 md:mt-0 justify-content-center md:justify-content-end">
                    <button class="custom-button bg-red-600 text-white w-9 py-4 text-lg font-semibold"
                            (click)="toggleDialog()">
                        {{ 'sipo.delete-account' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <!--card-3 end-->

        <!--delete account dialog begin-->
        <div class="fixed flex top-0 left-0 w-full justify-content-center align-items-center z-5"
             *ngIf="isDeleteAccountDialogOpen"
             style="height: 100vh; background-color: rgba(50,50,50,0.62);">
            <div *ngIf="showConfirmButtons" class="w-3 p-3 border-round bg-white">
                <div>{{ 'sipo.delete-account-dialog-info' | translate }}
                </div>
                <div class="flex justify-content-end pt-5">
                    <p-button [label]="'sipo.cancel' | translate" severity="danger" size="small" icon="pi pi-times"
                              styleClass="mr-3" (click)="toggleDialog()"/>
                    <p-button [label]="'sipo.submit' | translate" severity="success" size="small" icon="pi pi-check"
                              (click)="deleteRequest()"
                    />
                </div>

            </div>

            <div *ngIf="!showConfirmButtons" class="w-3 p-3 border-round bg-white">

                <div class="text-center mb-3">
                    {{ 'sipo.delete-account-confirm-otp' | translate }}
                </div>

                <!-- OTP field centered -->
                <div class="flex justify-content-center my-3">
                    <p-inputOtp [(ngModel)]="otp" [length]="6"></p-inputOtp>
                </div>

                <!-- Fehlermeldung -->
                <div *ngIf="otpError" class="text-center mt-2 text-red-500 font-semibold">
                    {{ this.otpError | translate }}
                </div>

                <div class="flex justify-content-end pt-5">

                    <p-button
                        [label]="'sipo.cancel' | translate"
                        severity="success"
                        size="small"
                        icon="pi pi-times"
                        styleClass="mr-3"
                        (click)="toggleDialog()">
                    </p-button>


                    <p-button
                        [label]="'sipo.delete-account' | translate"
                        (click)="deleteConfirm()"
                        severity="danger"
                        size="small"
                        icon="pi pi-check">
                    </p-button>

                </div>

            </div>

        </div>
        <!--delete account dialog end-->
    </div>
</div>
